jQuery(($) => {
  let currentPage = $('#header .nav--primary').find('.current-menu-item')
  let currentPageAncestor = $('#header .nav--primary').find(
    '.current-menu-ancestor'
  )

  currentPage.children('a').addClass('active')
  currentPageAncestor.children('button').addClass('active')
})
